import React, { useEffect } from "react";
import {
  RecruitmentSteps,
  ScreenFlow,
  PreScreen,
  Loading,
} from "../../components";
import {
  saveButton,
  greenDot,
  connectMyEmr,
  Manual,
  uploadDocument,
} from "../theme/icons";
import { getTitle, countries } from "../../helpers";
import { AcknowledgementModal } from ".";
import { environment } from "../../constants";
import moment from "moment";

const Participant = (info) => {
  const {
    disabledTrials,
    onCloseModal,
    showAcknowledgement,
    loadingForModal,
    type,
    trial,
    studyId,
    firstname,
    lastname,
    city,
    country,
    zipcode,
    email,
    showEmailError,
    showFirstNameError,
    showLastNameError,
    gender,
    currentgender,
    patient_id,
    dob,
    phone,
    smokingstatus,
    primarylanguage,
    currentmedication,
    healthcondition,
    familyhistory,
    onTextInputChange,
    onRaceCheckboxChange,
    signUp,
    onAcknowledge,
    hideSteps,
    showPrescreening,
    showRegisterOptions,
    isLoading,
    questions,
    optionChange,
    onEnroll,
    show_patient_id,
    navigateOption,
    accept_terms,
    receive_notifications,
    onTermsCheckboxChange,
    onReceiveNotificationsCheckboxChange,
  } = info;
  const flowarray = [
    { title: "Home", link: "/" },
    { title: "Find Trials", link: "/#find_trial" },
    // {
    //   title: "Search Results",
    //   link: `/results?q=${condition}&in=${country}`,
    // },
    // { title: "Trial Details", link: `/trialdetails/${studyId}/${type}` },
    // { title: "Sign Up", link: `/enroll/${studyId}/${type}` },
  ];

  const registerOptions = [
    {
      id: 1,
      title: "Connect My EMR",
      icon: connectMyEmr,
    },
    {
      id: 2,
      title: "Upload Document",
      icon: uploadDocument,
    },
    {
      id: 3,
      title: "Enter Manually",
      icon: Manual,
    },
  ];

  // useEffect(()=>{
  //   window.scrollTo(0,0)
  // })

  return (
    <div>
      {hideSteps === true ? null : <RecruitmentSteps step={"Sign Up"} />}
      <div className="container">
        {isLoading === false ? (
          <Loading />
        ) : (
          <div className="trialdetails row">
            <div
              className={`col-sm-12 ${
                (environment === "PROD" && studyId === "STU01009") ||
                (environment === "STAGING" && studyId === "STU01006") ||
                (environment === "DEV" && studyId === "STU0001002")
                  ? "col-lg-12 col-md-12"
                  : "col-lg-9 col-md-9"
              }`}
            >
              {hideSteps === true ? null : (
                <div className="d-flex align-items-start justify-content-between">
                  <ScreenFlow flow={flowarray} />
                  <img src={saveButton} alt="save icon"></img>
                </div>
              )}
              {(environment === "PROD" && studyId === "STU01009") ||
              (environment === "STAGING" && studyId === "STU01006") ||
              (environment === "DEV" && studyId === "STU0001002") ? null : (
                <div className="mt-1 d-flex align-items-start justify-content-between">
                  <div>
                    <img className="mx-2" src={greenDot} alt="greendot"></img>
                    {studyId && studyId.startsWith("STU") === true ? (
                      <span>
                        {trial &&
                        trial.study_phase &&
                        trial.study_phase.length > 0
                          ? trial.study_phase
                          : trial &&
                              trial.nct_number &&
                              trial.nct_number.length > 0
                            ? trial.nct_number
                            : "None"}
                      </span>
                    ) : (
                      <span>
                        {trial && trial.phase && trial.phase.length > 0
                          ? trial.phase
                          : "None"}
                      </span>
                    )}
                    <span className="mx-1">{"|"}</span>
                    {studyId && studyId.startsWith("STU") === true ? (
                      <span className="mx-1">
                        {trial &&
                        trial.conditions &&
                        trial.conditions.length > 0
                          ? trial.conditions
                          : trial &&
                              trial.study_name &&
                              trial.study_name.length > 0
                            ? trial.study_name
                            : "None"}
                      </span>
                    ) : trial &&
                      trial.conditions &&
                      trial.conditions.length > 0 ? (
                      trial.conditions.length < 2 ? (
                        trial.conditions.map((disease, i) => (
                          <span key={i} className="">
                            {disease}
                          </span>
                        ))
                      ) : (
                        <span>
                          {/* {`${JSON.parse(trial.conditions)[0]}, ${
                          trial.conditions.length - 1
                        } more ...`} */}
                        </span>
                      )
                    ) : (
                      <span className="">{"None"}</span>
                    )}
                  </div>
                  {studyId.startsWith("STU") === true ? (
                    <div>
                      <h3 className="updated_date">
                        Last updated on{" "}
                        {moment(trial && trial.sys_updated_on).format(
                          "MMMM Do YYYY"
                        )}
                      </h3>
                    </div>
                  ) : null}
                </div>
              )}
              <div className="mt-2 enrollmentsheet_header">
                {(environment === "PROD" && studyId === "STU01009") ||
                (environment === "STAGING" && studyId === "STU01006") ||
                (environment === "DEV" && studyId === "STU0001002") ? null : (
                  <div>
                    {getTitle(type, trial)}
                    <h3 className="py-4">
                      Clinical Study Identifier:
                      <span style={{ color: "#006D9C" }} className="mx-4">
                        {studyId}
                      </span>
                    </h3>
                    <h3 className="my-4">Enrollment Sheet</h3>
                  </div>
                )}
                {/* <div className="my-4 d-flex align-items-center justify-content-between">
                <h2>Do you have an account already?</h2>
                <div className="col-sm-4 pr-0" style={{ borderRadius: "3px" }}>
                  <a
                    href="#"
                    className="signin d-flex align-items-center justify-content-center border rounded btn btn-lg"
                  >
                    SIGN IN
                  </a>
                </div>
              </div> */}
                <div className="my-3 d-flex align-items-center justify-content-around m-0 p-0">
                  {showRegisterOptions === true ? null : (
                    <div className="col-sm-1 col-md-1 col-lg-1 col-xs-1 text-left pl-0 d-none d-lg-block ">
                      <hr className="d-none d-lg-block" />
                    </div>
                  )}
                  {showPrescreening === true && isLoading === true ? (
                    <h3 className="mb-0 text-center col-xs-6">
                      Please fill the pre-screening questions
                    </h3>
                  ) : (
                    isLoading === true &&
                    (showRegisterOptions === true ? null : (
                      <h3 className="mb-0 text-center col-xs-6">
                        Please fill in the form below and press the button at
                        the bottom of the page to complete Sign Up
                      </h3>
                    ))
                  )}
                  <div className="col-sm-1 col-md-1 col-lg-1 col-xs-1 text-center pr-0 d-none d-lg-block ">
                    <hr className="d-none d-lg-block" />
                  </div>
                </div>
              </div>
              {showPrescreening === true && isLoading === true ? (
                <div className="my-3">
                  <PreScreen
                    questions={questions}
                    optionChange={optionChange}
                    onEnroll={onEnroll}
                  />
                </div>
              ) : showPrescreening === false && isLoading === false ? (
                <Loading />
              ) : showRegisterOptions === true ? (
                <div className="my-3">
                  <h6>Please select from one of options below</h6>
                  <div className="d-flex align-items-center justify-content-between">
                    {registerOptions.map((option) => (
                      <div
                        onClick={() => navigateOption(option.title)}
                        key={option.id}
                        style={{ backgroundColor: "#F3F3F3" }}
                        className="register_option p-5 m-2"
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <img
                            src={option.icon}
                            className="mr-5"
                            alt="register_icon"
                          ></img>
                          <h4 className="register_option_title">
                            {option.title}
                          </h4>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div>
                  <div className="row my-3">
                    <div className="col-sm-12 col-md-12 col-xs-12 col-lg-4 px-0">
                      <div className="textinput form-group">
                        <p>
                          {"Country "}
                          <span style={{ color: "red", fontSize: 13 }}>*</span>
                        </p>
                        <select
                          onChange={onTextInputChange}
                          className="p-2 form-control"
                          placeholder={"Select"}
                          name={"country"}
                          value={country}
                        >
                          {countries.map((nation, i) => (
                            <option key={i} value={nation}>
                              {nation}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-xs-12 col-lg-4 px-0">
                      <div className="textinput form-group">
                        <p>
                          {"City "}
                          <span style={{ color: "red", fontSize: 13 }}>*</span>
                        </p>
                        <input
                          type="text"
                          className="p-2 form-control"
                          name={"city"}
                          onChange={onTextInputChange}
                          value={city}
                          placeholder={"Enter"}
                        ></input>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-xs-12 col-lg-4 px-0">
                      <div className="textinput form-group">
                        <p>
                          {"Zipcode "}
                          <span style={{ color: "red", fontSize: 13 }}>*</span>
                        </p>
                        <input
                          type="number"
                          className="p-2 form-control"
                          name={"zipcode"}
                          onChange={onTextInputChange}
                          value={zipcode}
                          placeholder={"Enter"}
                        ></input>
                      </div>
                    </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-sm-12 col-md-12 col-xs-12 col-lg-4 px-0">
                      <div className="textinput form-group">
                        <p>
                          {"First Name "}
                          <span style={{ color: "red", fontSize: 13 }}>*</span>
                        </p>
                        <input
                          type="text"
                          className="p-2 form-control"
                          name={"firstname"}
                          onChange={onTextInputChange}
                          value={firstname}
                          placeholder={"Enter"}
                        ></input>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-xs-12 col-lg-4 px-0">
                      <div className="textinput form-group">
                        <p>
                          {"Last Name "}
                          <span style={{ color: "red", fontSize: 13 }}>*</span>
                        </p>
                        <input
                          type="text"
                          className="p-2 form-control"
                          name={"lastname"}
                          onChange={onTextInputChange}
                          value={lastname}
                          placeholder={"Enter"}
                        ></input>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-xs-12 col-lg-4 px-0">
                      <div className="textinput form-group">
                        <p>
                          {"Email "}
                          <span style={{ color: "red", fontSize: 13 }}>*</span>
                        </p>
                        <input
                          type="email"
                          className="p-2 form-control"
                          name={"email"}
                          onChange={onTextInputChange}
                          value={email}
                          placeholder={"Enter"}
                        ></input>
                        {showEmailError ? (
                          <p style={{ color: "red" }} className="mb-0">
                            Please enter valid email
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-sm-12 col-md-12 col-xs-12 col-lg-4 px-0">
                      <div className="textinput form-group">
                        <p>
                          {"Gender at Birth "}
                          <span style={{ color: "red", fontSize: 13 }}>*</span>
                        </p>
                        <select
                          onChange={onTextInputChange}
                          className="pl-2 form-control"
                          placeholder={"Select"}
                          name={"gender"}
                          value={gender}
                        >
                          {[
                            { title: "Please Select", value: " " },
                            { title: "Male", value: "male" },
                            { title: "Female", value: "female" },
                          ].map((selectoption, i) => (
                            <option key={i} value={selectoption.value}>
                              {selectoption.title}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-xs-12 col-lg-4 px-0">
                      <div className="textinput form-group">
                        <p>{"Current Gender "}</p>
                        <input
                          type="text"
                          className="p-2 form-control"
                          name={"currentgender"}
                          onChange={onTextInputChange}
                          value={currentgender}
                          placeholder={"Enter"}
                        ></input>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-xs-12 col-lg-4 px-0">
                      <div className="textinput form-group">
                        <p>
                          {"Date of Birth "}
                          <span style={{ color: "red", fontSize: 13 }}>*</span>
                        </p>
                        <input
                          type="date"
                          className="p-2 form-control"
                          name={"dob"}
                          onChange={onTextInputChange}
                          value={dob}
                          placeholder={"DD/MM/YYYY"}
                        ></input>
                      </div>
                    </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-sm-12 col-md-12 col-xs-12 col-lg-4 px-0">
                      <div className="textinput mt-2 form-group">
                        <p>
                          {"Primary Contact Number "}
                          <span style={{ color: "red", fontSize: 13 }}>*</span>
                        </p>
                        <input
                          type="number"
                          className="p-2 form-control"
                          name={"phone"}
                          onChange={onTextInputChange}
                          value={phone}
                          placeholder={"Enter"}
                        ></input>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-xs-12 col-lg-4 px-0">
                      <div className="textinput mt-2 form-group">
                        <p>
                          {"Smoking Status "}
                          <span style={{ color: "red", fontSize: 13 }}>*</span>
                        </p>
                        <select
                          onChange={onTextInputChange}
                          className="p-2 form-control"
                          placeholder={"Select"}
                          name={"smokingstatus"}
                          value={smokingstatus}
                        >
                          {[
                            { title: "Please Select", value: " " },
                            { title: "Current", value: "Current" },
                            { title: "Ex", value: "Ex" },
                            { title: "Never", value: "Never" },
                          ].map((selectoption, i) => (
                            <option key={i} value={selectoption.value}>
                              {selectoption.title}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-xs-12 col-lg-4 px-0">
                      <div className="textinput mt-2 form-group">
                        <p>
                          {"Primary Language "}
                          <span style={{ color: "red", fontSize: 13 }}>*</span>
                        </p>
                        <select
                          onChange={onTextInputChange}
                          className="p-2 form-control"
                          placeholder={"Select"}
                          name={"primarylanguage"}
                          value={primarylanguage}
                        >
                          {[
                            { title: "Please Select", value: " " },
                            { title: "English", value: "en" },
                            { title: "Spanish", value: "sp" },
                            { title: "Vietnamese", value: "vt" },
                          ].map((selectoption, i) => (
                            <option key={i} value={selectoption.value}>
                              {selectoption.title}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  {show_patient_id === "true" ? (
                    <div className="row my-3">
                      <div className="col-sm-12 col-md-12 col-xs-12 col-lg-4 px-0">
                        <div className="textinput mt-2 form-group">
                          <p>{"Patient ID"}</p>
                          <input
                            type="text"
                            onChange={onTextInputChange}
                            className="p-2 form-control"
                            placeholder={"Enter Patient ID"}
                            name={"patient_id"}
                            value={patient_id}
                          ></input>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="textinput my-3">
                    <p className="mb-0">
                      How do you identify your race or ethnicity?{" "}
                      <span style={{ color: "red", fontSize: 13 }}>*</span>
                    </p>
                    {[
                      {
                        title: "American Indian or Alaskan Native",
                        value: "American Indian or Alaskan Native",
                      },
                      {
                        title: "Asian or Pacific Islander",
                        value: "Asian or Pacific Islander",
                      },
                      {
                        title: "Black or African American",
                        value: "Black or African American",
                      },
                      {
                        title: "Hispanic or Latino",
                        value: "Hispanic or Latino",
                      },
                      {
                        title: "White or Caucasian",
                        value: "White or Caucasian",
                      },
                      {
                        title: "(Mixed Race) American Indian or Alaskan Native",
                        value: "(Mixed Race) American Indian or Alaskan Native",
                      },
                      {
                        title: "(Mixed Race) Asian or Pacific Islander",
                        value: "(Mixed Race) Asian or Pacific Islander",
                      },
                      {
                        title: "(Mixed Race) Black or African American",
                        value: "(Mixed Race) Black or African American",
                      },
                      {
                        title: "(Mixed Race) Hispanic or Latino",
                        value: "(Mixed Race) Hispanic or Latino",
                      },
                      {
                        title: "(Mixed Race) White or Caucasian",
                        value: "(Mixed Race) White or Caucasian",
                      },
                    ].map((raceItem, i) => (
                      <div key={i} className="promo_answer">
                        <input
                          style={{ height: "auto", width: "auto" }}
                          className="mx-1 mt-2"
                          type={"checkbox"}
                          onChange={(e) =>
                            onRaceCheckboxChange(e, raceItem.title)
                          }
                          name={raceItem.value}
                          value={raceItem.value}
                        />
                        <span className="mx-2">{raceItem.title}</span>
                      </div>
                    ))}
                  </div>
                  <div className="">
                    <div className="pl-0">
                      <div className="textinput form-group">
                        <p>{"Current Medication"}</p>
                        <textarea
                          className="col-12 p-2 form-control"
                          type="text"
                          name={"currentmedication"}
                          onChange={onTextInputChange}
                          value={currentmedication}
                          placeholder={"Enter"}
                        ></textarea>
                      </div>
                    </div>
                    <div className="pl-0">
                      <div className="textinput form-group">
                        <p className="pl-2 mb-0">
                          {"Health Condition "}
                          <span style={{ color: "red", fontSize: 13 }}>*</span>
                        </p>
                        <textarea
                          className="col-12 p-2 form-control"
                          type="text"
                          name={"healthcondition"}
                          onChange={onTextInputChange}
                          value={healthcondition}
                          placeholder={"Enter"}
                        ></textarea>
                      </div>
                    </div>
                    <div className="pl-0">
                      <div className="textinput form-group">
                        <p>{"Relevant Family History"}</p>
                        <textarea
                          className="col-12 p-2 form-control"
                          type="text"
                          name={"familyhistory"}
                          onChange={onTextInputChange}
                          value={familyhistory}
                          placeholder={"Enter"}
                        ></textarea>
                      </div>
                    </div>

                    <div className="my-3">
                      <h6 className="px-2">
                        By providing your phone number, you agree to receive SMS
                        notifications from PatienTrials. Message frequency
                        varies. Message and data rates may apply. Reply{" "}
                        <span style={{ fontWeight: "normal" }}>STOP</span> to
                        unsubscribe. Reply{" "}
                        <span style={{ fontWeight: "normal" }}>HELP</span> for
                        customer support. View our{" "}
                        <a
                          href="https://app.termly.io/document/privacy-policy/1dafd99f-d664-43fa-873a-d046293e77c2"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#000", textDecoration: "underline" }}
                        >
                          Privacy Policy
                        </a>
                        .
                      </h6>
                      <div className="px-2">
                        <input
                          style={{ height: "auto", width: "auto" }}
                          className="mx-1"
                          type={"checkbox"}
                          onChange={onReceiveNotificationsCheckboxChange}
                          name={"receive_notifications"}
                          checked={
                            receive_notifications === true ? true : false
                          }
                          value={receive_notifications}
                          id="receive_notifications"
                        />
                        <label
                          className="ml-2 mb-0"
                          htmlFor="receive_notifications"
                        >
                          I consent to receive periodic notifications via SMS,
                          WhatsApp, and the mobile app.
                        </label>
                      </div>
                      <div className="px-2">
                        <input
                          style={{ height: "auto", width: "auto" }}
                          className="mx-1"
                          type={"checkbox"}
                          onChange={onTermsCheckboxChange}
                          name={"accept_terms"}
                          checked={accept_terms === true ? true : false}
                          value={accept_terms}
                          id="accept_terms"
                        />
                        <label className="ml-2 mb-0" htmlFor="accept_terms">
                          I have read and accept the{" "}
                          <a
                            href="https://app.termly.io/document/privacy-policy/1dafd99f-d664-43fa-873a-d046293e77c2"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#000",
                              textDecoration: "underline",
                            }}
                          >
                            Privacy Policy
                          </a>{" "}
                          and{" "}
                          <a
                            href="https://app.termly.io/document/terms-of-use-for-saas/c82c310a-9a7f-435e-88d7-2d7fafc9ecef"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#000",
                              textDecoration: "underline",
                            }}
                          >
                            Terms & Conditions
                          </a>
                          .
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="my-2 d-flex align-items-center justify-content-end">
                    <AcknowledgementModal
                      accept_terms={accept_terms}
                      receive_notifications={receive_notifications}
                      disabledTrials={disabledTrials}
                      loadingForModal={loadingForModal}
                      onCloseModal={onCloseModal}
                      signUp={signUp}
                      onAcknowledge={onAcknowledge}
                      showAcknowledgement={showAcknowledgement}
                    />
                  </div>
                </div>
              )}
            </div>
            {(environment === "PROD" && studyId === "STU01009") ||
            (environment === "STAGING" && studyId === "STU01006") ||
            (environment === "DEV" && studyId === "STU0001002") ? null : (
              <div className="closestlocation h-75 col-sm-12 col-md-3 col-lg-3 p-4 mt-5 text-left">
                <h2>YOU'RE ENROLLING TRIAL AT</h2>
                <h3>{trial && trial.site_name}</h3>
                <h2>
                  {trial &&
                    trial.street_address + trial &&
                    trial.city + trial &&
                    trial.state}
                </h2>
                {/* <div className="notification text-left">
              <h2>GET NOTIFIED</h2>
              <br></br>
              <h2>
                Sign up to receive email notification when clinical trials are
                posted in the medical category of interest to you.{" "}
              </h2>
              <div style={{ border: "1px solid #E57D24", borderRadius: "3px" }}>
                <a
                  href="#"
                  className="turn-on-notification d-flex align-items-center justify-content-center border rounded btn btn-lg"
                >
                  TURN ON NOTIFICATION
                </a>
              </div>
            </div> */}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Participant;
